
import axios from 'axios';
import { getToken, removeToken } from './auth';
import { Message } from 'element-ui';
import { MessageBox } from 'element-ui';
import CryptoJS from 'crypto-js';

// 基本配置
const instance = axios.create({
  baseURL: 'https://iot.bosfits.com', // 根据实际情况修改API地址
 // baseURL: 'http://192.168.1.127:9095',
  timeout: 5000 // 设置超时时间，单位为ms
});

// 请求拦截器
instance.interceptors.request.use(config => {
  config.headers['token'] = getToken(); // 设置请求头部分，这里举例使用了localStorage存储的token作为身份标识

  let str = config.url.split('/')

  //console.log(str)
  // if (str[2] == 'specification') {
  //
  //   config.baseURL = 'http://192.168.1.235:9095'
  //
  // }
  // console.log(str)
  // if (str[2] == 'action') {

  //   config.baseURL = 'http://192.168.1.235:9096'

  // }


  // if (str[2] == 'course') {

  //   config.baseURL = 'http://192.168.1.235:9096'

  // }


  // if (str[2] == 'scene') {
    
  //   config.baseURL = 'http://192.168.1.235:9096'

  // }

  // if (str[2] == 'EWorkoutData') {

  //   config.baseURL = 'http://192.168.1.235:9096'

  // }



  return config;
}, error => {
  console.log(error);
  return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use(response => {
  const data = response.data;

  if (data && data.code == 401) { // 根据接口返回的状态码判断是否有错误
    MessageBox.confirm(
      '登录状态已过期，您可以继续留在该页面，或者重新登录',
      '系统提示',
      { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
        removeToken()
        location.href = '/login';

      }).catch(() => {

      });


    return Promise.reject(new Error(data.message));
  } else if (data && data.code == 200) {
    return data;
  }
  else {

    Message({
      showClose: true,
      message: data.message,
      type: 'error'
    });
    return Promise.reject(new Error(data.message));
  }
}, error => {
  console.log(error);
  return Promise.reject(error);
});

export default instance;
